// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bhy_h bhy_kh bhy_we bhy_su bhy_vt bhy_sw bhy_sn"};